import { z } from 'zod';

export const Country = z.enum(['cn', 'jp']);

export type Country = z.infer<typeof Country>;
